// 通用构件 实体
import store from "@/store/index";
import {
  addEntityToDrawing,
  calculateDistanceAndAngle,
} from "@/rlMxModules/operate/operateApi";

import rlBaseData from "./rlBaseData";
import { rlTextData } from "@/rlMxModules/rlDataClass/index";
import { McDbPolyline, McCmColor, McGePoint3d, McDbText } from "mxcad";
class rlModelData extends rlBaseData {
  geometry = new THREE.BufferGeometry();
  material = new THREE.MeshBasicMaterial({
    transparent: true,
  });
  // bufferAttribute = new THREE.BufferAttribute(new Float32Array(), 3);
  edgeLineMaterial = new THREE.LineBasicMaterial({
    color: new THREE.Color("#000"),
  });
  constructor() {
    super();
    this.index2dData = null; // 二维平面点集
    this.index3dData = null; // 三维面数据集合
    this.ModelNo = null; //构件编号

    this.m_sectParamData = {}; //截面参数数据
    this.SectData = []; //截面组合数据
    // this.ID = null // 数据库ID
    // this.Guid = null //Guid
    this.LevelB = null; //底标高
    this.Height = null; //层高
    this.m_sectGroupName = ""; //截面类型分组名称
    this.Strength = ""; //构件强度
    this.StrengthOther = ""; //钢筋强度--混凝土或者砂浆强度--砌体
    this.Attribute = 1; //构件类型-:1：主要构件，2：一般构件，
    this.Color = "#ffffff";
    this.m_TextObj = null; //文字对象
    this.fontSize = store.state.platBtns.fontSize; //字体大小
    this.ModelType = ""; //构件类型，用于判断是否是构件数据

    this.mcDbPolyline = new McDbPolyline(); //多段线对象
    this.mcDbId = null; //多段线对象id

    this.isWasmGeted = false; //是否已经获取wasm数据
    this.OtherData = "";
    this.StrengthTextObj = null; //强度文字对象
    this.ModelNoTextObj = null; //构件号文字对象
    //this.rlLayer = store.state.cadModules.rlLayer
    //store.subscribe(this.handleLayerChange)
    this.CurrtSect = ""; //记录当前的截面尺寸，用于判断是否需要更新
  }

  initData(obj) {
    super.initData(obj);
    this.No_ = obj.No_;
    this.m_sectParamData = obj.m_sectParamData;
    this.Color = obj.Color;
    this.index2dData = obj.index2dData;

    this.index3dData = obj.index3dData;
    if (
      this.classTypeName !== "rlWallHole" &&
      this.classTypeName !== "SlabHole"
    ) {
      this.Strength = obj.Strength ? obj.Strength : null;
      this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
      this.Attribute = obj.Attribute;
      this.LinkGuids = obj.LinkGuids;
      this.ModelNo = obj.ModelNo;
    }
    this.LevelB = obj.LevelB;
    this.Height = Number(obj.Height);
    this.points = obj.points;

    if (typeof obj.OtherData == "string") {
      this.OtherData = obj.OtherData;
    } else {
      this.OtherData = JSON.stringify(obj.OtherData);
    }

    this.CurrtSect = obj.CurrtSect;
    // this.ModelType = obj.ModelType;
  }

  getModelDrawData(modelData) {
    this.index2dData = modelData["upViewData"];

    this.SectData = modelData["SectData"];

    this.OtherData = modelData;

    let drawing_3d = modelData["Drawing_3D"];

    this.points = drawing_3d.points;
    this.index3dData = {
      points: drawing_3d.points,
      faces: drawing_3d.faces,
    };
  }

  // 绘制
  draw() {
    this.convert();
    if (!this.index2dData && !this.index3dData) return;

    if (!this.isWasmGeted) this.isWasmGeted = true;
    // if ((!this.index2dData && !this.index3dData) || !this.isWasmGeted) {
    //   this.convert();
    //   this.isWasmGeted = false;
    // }

    if (this.index3dData.points) {
      this.points = this.index3dData.points;
      if (this.points) {
        let rlBuilding = store.state.cadModules.rlBuilding;
        this.points = this.points.map((item, index) => {
          if (index % 3 === 2) {
            return item + rlBuilding.LevelB;
          }
          return item;
        });
      }
    }

    // this.index3dData.points = this.points;
    if (this.mcDbId) {
      this.mcDbId.getMcDbEntity().erase();
      this.mcDbPolyline = new McDbPolyline();
    }

    this.mcDbPolyline.setxDataString("Guid", this.Guid);
    this.mcDbPolyline.setxDataString("classTypeName", this.classTypeName);

    // 构件显示控制
    if (this.classTypeName == "rlColSeg") {
      if (this.Attribute == 1) {
        this.mcDbPolyline.visible = store.state.displayData.cloumnDisplay;
      } else {
        this.mcDbPolyline.visible =
          store.state.displayData.constructionColDisplay;
      }
    } else if (
      this.classTypeName == "rlRingBeamSeg" ||
      (this.classTypeName == "rlBeamSeg" &&
        this.m_sectParamData.IsRingBeamSeg == 1)
    ) {
      this.mcDbPolyline.visible = store.state.displayData.ringDisplay;
    } else if (this.classTypeName == "rlBeamSeg" && this.Attribute == 1) {
      this.mcDbPolyline.visible = store.state.displayData.beamDisplay;
    } else if (this.classTypeName == "rlWallSeg") {
      this.mcDbPolyline.visible = store.state.displayData.wallDisplay;
    } else if (
      this.classTypeName == "rlSlab" ||
      this.classTypeName == "rlSlabHole"
    ) {
      this.mcDbPolyline.visible = store.state.displayData.slabDisplay;
    } else if (
      this.classTypeName == "rlSubBeam" ||
      (this.classTypeName == "rlBeamSeg" && this.Attribute == 2)
    ) {
      this.mcDbPolyline.visible = store.state.displayData.subBeamDisplay;
    } else if (this.classTypeName == "rlWallHole") {
      if (this.doorsWindowsType == 1) {
        this.mcDbPolyline.visible = store.state.displayData.doorsDisplay;
      } else if (this.doorsWindowsType == 0) {
        this.mcDbPolyline.visible = store.state.displayData.windowsDisplay;
      } else {
        this.mcDbPolyline.visible = store.state.displayData.wallHoleDisplay;
      }
    } else if (this.classTypeName == "rlDoorsWindows") {
      if (this.doorsWindowsType == 1) {
        this.mcDbPolyline.visible = store.state.displayData.doorsDisplay;
      } else {
        this.mcDbPolyline.visible = store.state.displayData.windowsDisplay;
      }
    } else if (this.classTypeName == "rlPartitionWallSeg") {
      if (this.m_HoleIdArray.length === 0) {
        this.mcDbPolyline.visible =
          store.state.displayData.partitionWallDisplay;
      } else {
        this.mcDbPolyline.visible = false;
      }
    }

    if (this.Color) {
      this.mcDbPolyline.trueColor = new McCmColor(
        this.Color.r,
        this.Color.g,
        this.Color.b
      );
    }
    this.create2dModel(this.index2dData, this.mcDbPolyline);

    if (!this.index3dData || !this.index3dData.points) return;

    this._threeObj = this.create3dModel(
      this.points,
      Array.isArray(this.index3dData)
        ? this.index3dData
        : this.index3dData.faces
    );

    if (this.m_TextObj && this.m_TextObj.mcDbId) {
      this.m_TextObj.mcDbId.getMcDbEntity().textString = this.m_sectGroupName;
    }
  }

  create2dModel(points, pWorldDraw) {
    if (points) {
      for (let i = 0; i < points.length; i += 3) {
        pWorldDraw.addVertexAt(new McGePoint3d(points[i], points[i + 1], 0));
      }
    }
    pWorldDraw.isClosed = true;
  }

  // 三维
  create3dModel(point, indexData) {
    if (!this.Color) return;

    const geometry = new THREE.BufferGeometry();
    const material = new THREE.MeshBasicMaterial({ transparent: true });

    let vertices = [];
    if (point.every((value) => typeof value === "number" && !isNaN(value))) {
      vertices = new Float32Array(point);
    }
    geometry.setAttribute("position", new THREE.BufferAttribute(vertices, 3));
    geometry.setIndex(indexData);
    geometry.scale(1 - this.deviation, 1 - this.deviation, 1 - this.deviation);
    // 计算法线
    // this.geometry.computeVertexNormals();

    if (this.componentType == "SlabHole") {
      material.color = new THREE.Color(173 / 255, 153 / 255, 153 / 255);
    } else {
      material.color = new THREE.Color(
        this.Color.r / 255,
        this.Color.g / 255,
        this.Color.b / 255
      );
    }
    material.opacity = this.Color.a;
    material.transparent = this.Color.a == 1 ? false : true;
    material.side = THREE.DoubleSide;
    material.depthTest = true; // 深度测试
    material.depthWrite = true; // 深度写入

    const tCubeObj = new THREE.Mesh(geometry, material);
    return tCubeObj;
  }

  // 创建字体
  createText() {
    if (this.m_TextObj) {
      this.m_TextObj.erase();
    }
    let visible =
      this.mcDbPolyline?.visible && store.state.displayData.sectSizeDisplay;
    let points = this.index2dData;
    if (!points) return;
    let sumX = 0;
    let sumY = 0;
    let maxX = -Infinity;
    let minX = Infinity;

    // 计算中心点
    for (let i = 0; i < points.length; i += 3) {
      const x = points[i];
      const y = points[i + 1];
      sumX += x;
      sumY += y;
      maxX = Math.max(maxX, x);
      minX = Math.min(minX, x);
    }

    // 计算中心点的xy坐标
    const centerX = sumX / (points.length / 3);
    const centerY = sumY / (points.length / 3);
    const centerPoint = new THREE.Vector3(centerX, centerY, 0);
    let angleText = 0;
    if (
      (this.classTypeName == "rlBeamSeg" ||
        this.classTypeName == "rlWallSeg" ||
        this.classTypeName == "rlPartitionWallSeg" ||
        this.classTypeName == "rlWallHole") &&
      this.m_gridData?.classTypeName == "rlGrid"
    ) {
      //判断网格方向
      const pt1 = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
      const pt2 = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
      let { angle } = calculateDistanceAndAngle(pt1, pt2);
      if (angle == 180) angle = 0;
      if (angle == 270) angle = 90;
      //转换成弧度
      angleText = angle * (Math.PI / 180);
      if (this.classTypeName != "rlWallHole") {
        const vec = pt2.clone().sub(pt1).normalize();
        //将构件号的位置偏移200mm
        let vecWidth = vec.cross(new THREE.Vector3(0, 0, 1));
        vecWidth.normalize();

        centerPoint.x -= Math.abs(vecWidth.x) * 200;
        centerPoint.y += Math.abs(vecWidth.y) * 200;
      }
    }
    this.m_TextObj = new rlTextData();
    this.m_TextObj.position = centerPoint;
    this.m_TextObj.Text = this.m_sectGroupName;
    this.m_TextObj.fontSize = store.state.platBtns.fontSize;
    this.m_TextObj.textType = "截面尺寸";
    this.m_TextObj.belongObjId = this.mcDbId;
    this.m_TextObj.dAngle = angleText;
    this.m_TextObj.draw(visible);
    this.m_TextObj.lineObjId = this.m_TextObj.mcDbId;
  }

  // 创建强度文字
  createStrengthText(visible) {
    // if (!this.Strength || !this.mcDbId) return;
    // console.log("创建文字");
    let Text = this.Strength;
    const otherData =
      this.OtherData && typeof this.OtherData === "string"
        ? JSON.parse(this.OtherData)
        : this.OtherData || {};
    const otherStrengthData = otherData.otherStrengthData || "";
    if (otherStrengthData && !(otherStrengthData instanceof Array)) {
      Text = `砖:${
        otherStrengthData.brick_strength || this.Strength || ""
      }砂浆:${otherStrengthData.mortar_strength}`;
    }
    if (this.StrengthTextObj && this.StrengthTextObj.mcDbId) {
      this.StrengthTextObj.mcDbId.getMcDbEntity().visible = visible;
      this.StrengthTextObj.mcDbId.getMcDbEntity().textString = Text;
    } else {
      let points = this.index2dData;
      if (!points) return;
      let sumX = 0;
      let sumY = 0;
      let maxX = -Infinity;
      let minX = Infinity;
      // 计算中心点
      for (let i = 0; i < points.length; i += 3) {
        const x = points[i];
        const y = points[i + 1];
        sumX += x;
        sumY += y;
        maxX = Math.max(maxX, x);
        minX = Math.min(minX, x);
      }

      // 计算中心点的xy坐标
      const centerX = sumX / (points.length / 3);
      let centerY = sumY / (points.length / 3);
      if (this.ModelType === "墙") {
        centerY += this.fontSize;
      }
      const centerPoint = new THREE.Vector3(centerX, centerY, 0);
      this.StrengthTextObj = new rlTextData();
      this.StrengthTextObj.position = centerPoint;
      this.StrengthTextObj.Text = Text;
      this.StrengthTextObj.fontSize = this.fontSize;
      this.StrengthTextObj.textType = "强度";
      this.StrengthTextObj.belongObjId = this.mcDbId;
      this.StrengthTextObj.draw(visible);
    }
  }

  // 创建构件号文字
  createModelNoText() {
    if (this.ModelNoTextObj) {
      this.ModelNoTextObj.erase();
    }
    let visible =
      this.mcDbPolyline?.visible && store.state.displayData.modelNoDisplay;

    let sectSizeDisplay = store.state.displayData.sectSizeDisplay;
    let sectHeight = 0;
    if (sectSizeDisplay && this.m_TextObj) {
      sectHeight = this.m_TextObj.fontSize;
    }

    //设置构件号颜色
    let color = new McCmColor(255, 0, 0);

    if (this.classTypeName == "rlBeamSeg") {
      color = new McCmColor(34, 34, 34);
    } else if (this.classTypeName == "rlWallSeg") {
      color = new McCmColor(0, 0, 255); //蓝色
    } else if (this.classTypeName == "rlSlab") {
      color = new McCmColor(0, 102, 0);
    } else if (this.classTypeName == "rlPartitionWallSeg") {
      color = new McCmColor(128, 0, 128); //紫色
    }

    // if (this.Guid == "159254a2-49e6-432a-9df6-c8da0918e91b") debugger;
    // if (!this.ModelNo || !this.mcDbId) return;
    // if (this.ModelNoTextObj && this.ModelNoTextObj.mcDbId) {
    //   this.ModelNoTextObj.mcDbId.getMcDbEntity().visible = visible;
    //   this.ModelNoTextObj.mcDbId.getMcDbEntity().textString = this.ModelNo;
    // } else {
    let points = this.index2dData;
    if (!points) return;
    let sumX = 0;
    let sumY = 0;
    let maxX = -Infinity;
    let minX = Infinity;
    // 计算中心点
    for (let i = 0; i < points.length; i += 3) {
      const x = points[i];
      const y = points[i + 1];
      sumX += x;
      sumY += y;
      maxX = Math.max(maxX, x);
      minX = Math.min(minX, x);
    }

    // 计算中心点的xy坐标
    const centerX = sumX / (points.length / 3);
    const centerY = sumY / (points.length / 3);
    let centerPoint = new THREE.Vector3(centerX, centerY, 0);

    let angle = 0;
    if (this.m_gridData && this.m_gridData.classTypeName == "rlGrid") {
      //判断网格方向
      const pt1 = new THREE.Vector3(...this.m_gridData.m_stJoint.m_pt);
      const pt2 = new THREE.Vector3(...this.m_gridData.m_edJoint.m_pt);
      if (this.classTypeName == "rlPartitionWallSeg" && this.m_wallHoleId) {
        centerPoint = new THREE.Vector3().lerpVectors(pt1, pt2, 0.5);
      }

      const vec = pt2.clone().sub(pt1).normalize();
      //若vec方向指向左下，则取反
      if (vec.x < 0 || vec.y < 0) {
        vec.multiplyScalar(-1);
      }
      angle = vec.angleTo(new THREE.Vector3(1, 0, 0));

      //将构件号的位置偏移200mm
      let vecWidth = vec.cross(new THREE.Vector3(0, 0, 1));
      vecWidth.normalize();

      centerPoint.x -= Math.abs(vecWidth.x) * (sectHeight + 500);
      centerPoint.y += Math.abs(vecWidth.y) * (sectHeight + 500);
    } else {
      // centerPoint.x += 300;
      centerPoint.y -= 300;
    }

    this.ModelNoTextObj = new rlTextData();
    this.ModelNoTextObj.position = centerPoint;
    this.ModelNoTextObj.Text = this.ModelNo;
    this.ModelNoTextObj.fontSize = this.fontSize;
    this.ModelNoTextObj.textType =
      this.classTypeName == "rlSlab" ? "楼板构件号" : "构件号";
    this.ModelNoTextObj.belongObjId = this.mcDbId;
    this.ModelNoTextObj.dAngle = angle;
    this.ModelNoTextObj.color = color;
    this.ModelNoTextObj.draw(visible);
    // }
  }

  cloneData(newObj) {
    // let newObj = new rlModelData();
    newObj.SectData = this.SectData;
    newObj.m_sectParamData = this.m_sectParamData;
    newObj.index3dData = this.index3dData;
    newObj.index2dData = this.index2dData;
    newObj.points = this.points;
    newObj.StdFlrGuid = this.StdFlrGuid;
    newObj.ModelNo = this.ModelNo;
    newObj.Strength = this.Strength;
    newObj.StrengthOther = this.StrengthOther;
    newObj.LevelB = this.LevelB;
    newObj.Height = this.Height;
    newObj.CurrtSect = this.CurrtSect;
    newObj.isWasmGeted = false; //是否已经获取wasm数据
    // newObj.mcDbPolyline = this.mcDbPolyline;
    // return newObj;
  }

  // 偏移
  transformBy(_mat) {
    // 定义平移的偏移量
    const offsetX = _mat.x;
    const offsetY = _mat.y;
    const offsetZ = _mat.z;

    // 对每个坐标进行平移操作
    for (let i = 0; i < this.index2dData.length; i += 3) {
      this.index2dData[i] += offsetX; // 平移 x 坐标
      this.index2dData[i + 1] += offsetY; // 平移 y 坐标
      this.index2dData[i + 2] += offsetZ; // 平移 z 坐标
    }
    // 对每个坐标进行平移操作
    for (let i = 0; i < this.points.length; i += 3) {
      this.points[i] += offsetX; // 平移 x 坐标
      this.points[i + 1] += offsetY; // 平移 y 坐标
      this.points[i + 2] += offsetZ; // 平移 z 坐标
    }

    // this.setNeedUpdateDisplay(true);
  }

  erase() {
    this.m_TextObj?.erase();
    this.StrengthTextObj?.erase();
    this.ModelNoTextObj?.erase();
    this.mcDbPolyline?.erase();
    this.mcDbId?.getMcDbEntity().erase();
    super.erase();
  }

  updateThisObj(obj, redraw = true) {
    this.initData(obj);
    if (redraw) {
      this.isWasmGeted = false;
      this.draw();
      this.mcDbId = rlAppObj.mxcadObject.drawEntity(this.mcDbPolyline);
      this.createModelNoText();
      this.createText();
    }

    super.updateThisObj(obj);
  }

  // 返回图形源数据
  getDataBase() {
    try {
      let data = super.getDataBase();
      data.No_ = this.No_;

      if (
        this.classTypeName !== "rlWallHole" &&
        this.classTypeName !== "rlSlabHole" &&
        this.classTypeName !== "rlDoorsWindows"
      ) {
        if (
          this.classTypeName !== "rlCantiSlab" &&
          this.classTypeName !== "rlPartitionWallSeg"
        ) {
          data["Strength"] = this.Strength;
          data["StrengthOther"] = this.StrengthOther;
        }
        if (this.classTypeName !== "rlPartitionWallSeg") {
          data["Attribute"] = this.Attribute;
        }
        data["ModelNo"] = this.ModelNo;
      }
      //草图布置的构件不保存以下数据,因为切换时同个构件的位置不一样,需要重新绘制
      if (!store.state.globalData.isSketch) {
        data["Drawing_2D"] =
          this.index2dData != "" && this.index2dData
            ? this.index2dData.join(",")
            : null;
        data["Drawing_3D"] =
          this.index3dData != "" ? JSON.stringify(this.index3dData) : null;
      }
      data["OtherData"] =
        typeof this.OtherData == "string"
          ? this.OtherData
          : JSON.stringify(this.OtherData);
      data["CurrtSect"] = this.CurrtSect;
      return data;
    } catch (error) {
      console.log("error", error);
      return null;
    }
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.No_ = obj.No_;
    this.m_sectParamData = obj.m_sectParamData;
    if (
      this.classTypeName !== "rlWallHole" &&
      this.classTypeName !== "SlabHole"
    ) {
      this.Strength = obj.Strength ? obj.Strength : null;
      this.StrengthOther = obj.StrengthOther ? obj.StrengthOther : null;
      this.Attribute = obj.Attribute;
      this.LinkGuids = obj.LinkGuids;
      this.ModelNo = obj.ModelNo;
    }
    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.OtherData = obj.OtherData;
    this.LevelB = obj.LevelB;
    this.Height = Number(obj.Height);
    this.ModelType = obj.ModelType;
    this.Color = obj.Color;
    this.CurrtSect = obj.CurrtSect;
  }
  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();
    if (this.classTypeName !== "rlWallHole") {
      if (this.classTypeName !== "rlCantiSlab") {
        data["Strength"] = this.Strength;
        data["StrengthOther"] = this.StrengthOther;
      }
      data["Attribute"] = this.Attribute;
      data["ModelNo"] = this.ModelNo;
      data["SectData"] = this.SectData;
      data["CurrtSect"] = this.CurrtSect;
    }
    data["m_sectParamData"] = this.m_sectParamData;
    data["LevelB"] = this.LevelB;
    data["Height"] = this.Height;
    data["index2dData"] = this.index2dData;
    data["index3dData"] = this.index3dData;
    data["ModelType"] = this.ModelType;
    data["OtherData"] = JSON.stringify(this.OtherData);
    return data;
  }
}

export default rlModelData;
